import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const FAQ = () => {
  return (
    <div>
      <Header />

      <section className="py-12 bg-slate-50">
        <div className="w-[85%] md:w-[90%] sm:w-[95%] mx-auto">
          <h1 className="text-3xl font-bold mb-6">FAQ</h1>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white border rounded-md p-5">
              <h2 className="text-xl font-semibold mb-3">Seller FAQ</h2>
              <ul className="space-y-3 text-sm text-slate-600">
                <li><span className="font-semibold">How do I become a seller?</span> Register, complete profile, and upload required documents.</li>
                <li><span className="font-semibold">What documents are required?</span> Co License, VAT/GST, EID/Aadhaar, passport copy, photo.</li>
                <li><span className="font-semibold">How long does approval take?</span> Usually 24–48 hours after document verification.</li>
              </ul>
            </div>

            <div className="bg-white border rounded-md p-5">
              <h2 className="text-xl font-semibold mb-3">General FAQ</h2>
              <ul className="space-y-3 text-sm text-slate-600">
                <li><span className="font-semibold">How do I track my order?</span> Go to Dashboard → My Orders.</li>
                <li><span className="font-semibold">What payment methods are supported?</span> Online, COD, CDC, PDC (as available).</li>
                <li><span className="font-semibold">Can I return products?</span> If return is available, details are shown on the product page.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FAQ;
